// const config = {
//   apiBaseUrl: process.env.REACT_APP_BASE_URL,
//   stripePublicKey: process.env.stripe_public_key,
//   mediaUrl: process.env.REACT_APP_S3_URL,
//   encryptionSecretKey: process.env.REACT_APP_ENCRYPTION_SECRET_KEY,
// };

// export default config;
// live
const config = {
  // apiBaseUrl: "https://scalisi-backend-b11-ffab2eee62f7.herokuapp.com",
  apiBaseUrl: process.env.REACT_APP_BACKEND_URL,
  // apiBaseUrl: "https://sskw3ghk-3040.inc1.devtunnels.ms", non live

  // "https://sskw3ghk-3040.inc1.devtunnels.ms", 
  stripePublicKey: process.env.stripe_public_key,
  mediaUrl: "https://scalisi-produce.s3.us-east-2.amazonaws.com",
  encryptionSecretKey: process.env.REACT_APP_ENCRYPTION_SECRET_KEY,
};
// live
export default config;
